import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const ModulesIcon = createIcon({
  displayName: 'ModulesIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g
        xmlns="http://www.w3.org/2000/svg"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      >
        <path d="M7 6v-2c0-.552-.448-1-1-1h-2c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1h2c.552 0 1-.448 1-1Z" />
        <path d="M7.846 14v-1.846c0-.552-.448-1-1-1h-1.846c-.552 0-1 .448-1 1v1.846c0 .552.448 1 1 1h1.846c.552 0 1-.448 1-1Z" />
        <path d="M14 9v-2c0-.552-.448-1-1-1h-2c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1h2c.552 0 1-.448 1-1Z" />
        <path d="M13 17v-3c0-.552.448-1 1-1h3v-3c0-.552.448-1 1-1h2c.552 0 1 .448 1 1v10c0 .552-.448 1-1 1h-10c-.552 0-1-.448-1-1v-2c0-.552.448-1 1-1h3Z" />
      </g>
      <rect xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" />
    </>
  ),
})

const Modules: FC<IconProps> = (props) => {
  return <CustomIcon as={ModulesIcon} {...props} />
}

export default memo(Modules)
